import React from 'react';
import {getToken} from "../../Utils/Common";

function Signature(props) {

    const [cdnSign, setCDNSign] = React.useState("")

    React.useEffect(() => {

        async function getCDNImage() {
            const response = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/getpresignedurl", {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                },
                body: JSON.stringify({"token": getToken(), "data": {"object_path": props.image}})
            });

            return await response.json()

        }

        getCDNImage().then(response => setCDNSign(response.url))

    }, [])

    return (<>
        {props.type === 'anahme' && <>
            <div>
				<span>
                Anahme: {props.name}
            </span>
            </div>
        </>}

        {props.type === 'creatorSign' && <>
            <div>
                <br/>
                <span>
					<label className="handwai-text-label-main">Unterschrift</label>
                </span>
                <br/>
                <img src={cdnSign} height={150} width={300}/>
                <br/>
                <label className="handwai-text-label-normal">Unterschrieben von: {props.name} </label>
            </div>

        </>}
    </>)
}

export default Signature;
